import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  open(content: TemplateRef<any>, options) {
    console.log(options,'options')
    this.modalRef = this.modalService.open(content, options);
  }

  dismissAll() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
}
